var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2948 12.4164C13.2948 14.726 11.4396 16.5983 9.15125 16.5983C6.86289 16.5983 5.00757 14.726 5.00757 12.4164C5.00757 10.1068 6.86275 8.23438 9.15125 8.23438C11.4398 8.23438 13.2948 10.1068 13.2948 12.4164Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8407 12.4175C17.8407 14.5915 16.9131 16.3546 15.7689 16.3546C14.6246 16.3546 13.697 14.5915 13.697 12.4175C13.697 10.2435 14.6245 8.48047 15.7687 8.48047C16.913 8.48047 17.8406 10.243 17.8406 12.4175",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7001 12.4176C19.7001 14.365 19.3739 15.9446 18.9714 15.9446C18.569 15.9446 18.2429 14.3654 18.2429 12.4176C18.2429 10.4698 18.5691 8.89062 18.9714 8.89062C19.3738 8.89062 19.7001 10.4697 19.7001 12.4176Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.4edbf8fe.svg";
export { ForwardRef as ReactComponent };